import { render } from "./BillingConfirmView.vue?vue&type=template&id=5751e74e"
import script from "./BillingConfirmView.vue?vue&type=script&lang=js"
export * from "./BillingConfirmView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__